var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.833,
    height: 73.833,
    viewBox: "0 0 73.833 73.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1054.417 -446.417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.881,42.178a4.34,4.34,0,1,1,.745,2.392A4.379,4.379,0,0,1,10.881,42.178ZM12.288,31.5l-.547-20.41a3.519,3.519,0,1,1,7,0L18.231,31.5a2.972,2.972,0,0,1-5.943,0Z",
    transform: "translate(1076.077 456.404)",
    fill: "#2f6bc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.917,75.333A36.167,36.167,0,1,0,2.75,39.167,36.167,36.167,0,0,0,38.917,75.333Z",
    transform: "translate(1052.417 444.167)",
    fill: "none",
    stroke: "#2f6bc1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.f79d45af42436c597a54c6f7d38bfe24.svg";
export { ForwardRef as ReactComponent };